import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const InputWrapper = styled(FlexRow)`
    position: relative;
    padding: 8px 16px;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    border-radius: 69px;

    ${setFontVariant("button", colorsPalettes.blue[400])};

    &:hover {
        background-color: rgba(181, 190, 198, 0.2);
    }
`;

export const FileInput = styled.input`
    width: 100% !important;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: 1;

    &::-webkit-file-upload-button {
        cursor: pointer !important;
    }
`;
